import { render, staticRenderFns } from "./StaffMonthlyAttendanceTableControl.vue?vue&type=template&id=28d08f84&scoped=true&"
import script from "./StaffMonthlyAttendanceTableControl.vue?vue&type=script&lang=js&"
export * from "./StaffMonthlyAttendanceTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d08f84",
  null
  
)

export default component.exports